import { ArrowPathIcon } from "@heroicons/react/24/outline";

/** Outline icons from @heroicons/react/24/outline (shared component type). */
export type ReportMenuHeroIcon = typeof ArrowPathIcon;

/** Employee screening setup is not offered for 360 reports (Pending Review / Reviewed). */
export function canOfferEmployeeScreeningSetup(
  canCreateRecur: boolean | undefined,
  is360?: boolean
): boolean {
  return Boolean(canCreateRecur) && !is360;
}

export function renderReportMenuItem(
  IconComponent: ReportMenuHeroIcon,
  label: string,
  labelClassName?: string
) {
  return (
    <span className="flex items-center gap-3 min-w-[220px]">
      <IconComponent className="w-5 h-5 text-gray-500 shrink-0" />
      <span
        className={[labelClassName, "whitespace-normal break-words"]
          .filter(Boolean)
          .join(" ")}
      >
        {label}
      </span>
    </span>
  );
}
